import { createLazyImport } from './createLazyImport';

/**
 * Lazily loads the heavy echarts bundle once and shares the promise across consumers.
 */
export const getEchartsModule = createLazyImport(() => import('echarts'));
